import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Nav, Navbar, Container, Dropdown, Form } from 'react-bootstrap';
import { SignInButton } from '../components/login/SignInButton';
import { SignOutButton } from '../components/login/SignOutButton';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';
//import { SurveyResultsConfig } from '../components/SurveyResultsConfig';
//import { SurveyResultsContext } from '../components/context/SurveyResultsContext';

export function NavBar() {
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const name = activeAccount?.name ?? activeAccount?.idTokenClaims?.name; //`${accounts[0]?.idTokenClaims?.first_name} ${accounts[0]?.idTokenClaims?.last_name}`.trim();
    const username = activeAccount?.username ?? activeAccount?.idTokenClaims?.email;

    const [showNavBar, setShowNavBar] = useState(false);
    const [showSurveyResults, setshowSurveyResults] = useState(false);

    //const { config } = useContext(SurveyResultsContext);

    useEffect(() => {
      let path = location.pathname.toLowerCase();
        if(path.includes("/survey")) {
            setShowNavBar(false)
        } else {
            setShowNavBar(true)
        }
        if(path.includes("/results/"))
          setshowSurveyResults(true);
    }, [location])

  return ( showNavBar &&
    <Navbar variant="light" expand="lg" className='shadow-sm py-1 mb-2'>
    {/* <Navbar variant="dark" bg="dark" expand="lg"> */}
      <Container fluid>
        <Navbar.Brand href="/">
          <img height="50" src="/alignorg-lockup-brand.png" />
        </Navbar.Brand>
        <Nav style={{ gap: 15 }}>
          <Nav.Item>
            <Dropdown drop="down">
              <Dropdown.Toggle as="a" id="hamburger-dropdown" className='btn-primary navbar-button'>
                <FontAwesomeIcon className="h-100 w-100" pointerEvents={"none"} icon={faCircleUser} />
              </Dropdown.Toggle>

              <Dropdown.Menu align="end">
                {/* <div className='dropdown-custom-item'>
                  <Form.Label>Show Level options</Form.Label>
                </div>
                <div className='dropdown-custom-item'>
                  <Form.Check
                    type="switch"
                    label="Level"
                  />
                </div>
                <div className='dropdown-custom-item'>
                  <Form.Check
                    type="switch"
                    label="Function"
                  />
                </div> */}

                <div className="dropdown-custom-item">
                  <div style={{ fontSize: "18px", fontWeight: 500 }}>{name}</div>
                  <div>{username}</div>
                </div>
                <Dropdown.Divider />
                <div className='dropdown-custom-item'>
                  {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </Nav.Item>
        </Nav>
      </Container>
    </Navbar>
  )
}